import i18next from 'i18next';
import resources from './local-resources';

const languages = Object.keys(resources);
let defaultLang = (localStorage.getItem('language') || window.navigator.userLanguage || window.navigator.language || languages[0]).split('-')[0];
if (!languages.includes(defaultLang)) defaultLang = languages[0];

localStorage.setItem('language', defaultLang);

i18next.init({
    fallbackLng: languages,
    resources,
    ns: ['app'],
    defaultNS: 'app',
    lng: defaultLang,

    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },

    // special options for react-i18next
    // learn more: https://react.i18next.com/components/i18next-instance
    react: {
        wait: true
    }
});

export default i18next;